import React from 'react';

const Loading = ({ isFetching, isLoaded, imagesToGet }) => {
  if(!isLoaded) {
    return ( <div></div> )
  }
  if(imagesToGet) {
    var text = "";
  } else if(isFetching){
    text = "Getting more images..."
  } else {
    text = "No more images";
  }
  return (
    <div className={"fetching-area text-center " + isFetching}>
      <hr></hr>
      <p>{ text }</p>
    </div>
  )

}

export default Loading;